import { createAction } from "@reduxjs/toolkit";
import type { CreateAdminStudioBody } from "@shared-kernel/application/ports/admin/admin-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const createAdminStudio = createApiThunk<string, CreateAdminStudioBody>(
  "admin/studio/create",
  async (body, { extra: { adminRepository } }) => {
    return adminRepository!.createStudio(body);
  },
);

export const resetCreateAdminStudio = createAction("admin/studio/resetCreate");
